// extracted by mini-css-extract-plugin
export default {"base":"WidgetHeaderContent_base__CdsgB","title-wrapper":"WidgetHeaderContent_title-wrapper__VXsLb"};